
	import { UserType } from "@/domain/entities/UserTypes";
	import AuthFacade from "@/infraestructure/auth/auth_facade";
	import useNotification from "@/store/NotificationState";
	import useAuth from "@/store/AuthState";
	import { defineComponent, reactive, inject, ref } from "vue";
	import { useRouter } from "vue-router";

	export default defineComponent({
		name: "Login",

		setup() {
			const authFacade: AuthFacade = inject(AuthFacade.key) as AuthFacade;
			const { signIn, verifyDoctor } = useAuth();
			const { showSnackbar, SnackbarMessageLevel } = useNotification();
			const router = useRouter();
			const isRequestingAccessDoctor = ref(false);
			let isDoctorConfirmed = false;

			interface LoginPayload {
				email: string;
				password: string;
			}
			const loginPayload: LoginPayload = { email: "", password: "" };
			const loginState = reactive(loginPayload);

			async function doGmailLogin() {
				// this.email
				// this.password
				try {
					if (isRequestingAccessDoctor.value === false) {
						await signIn(UserType.Patient);
					} else if (
						isRequestingAccessDoctor.value === true &&
						isDoctorConfirmed
					) {
						await signIn(UserType.Doctor);
					}
					router.push({ name: "dashboard" });
				} catch (error) {
					console.error(error);
				}
			}

			async function logout() {
				await authFacade?.logout();
			}

			const keyword = ref<string>("");
			const isVerifyingDoctor = ref(false)
			const verifyIsDoctor = async () => {
				if (keyword.value === "") {
					showSnackbar("Ingresa la clave");
					return;
				}
				isVerifyingDoctor.value = true
				let responseIsDoctor: boolean = await verifyDoctor(keyword.value);
				isVerifyingDoctor.value = false
				showSnackbar(
					responseIsDoctor
						? "acceso otorgado"
						: "clave incorrecta. acceso cancelado",
					{
						level: responseIsDoctor
							? SnackbarMessageLevel.INFO
							: SnackbarMessageLevel.DANGER,
					}
				);
				if (!responseIsDoctor) {
					isDoctorConfirmed = false;
					keyword.value = "";
				} else {
					isDoctorConfirmed = true;
				}
			};
			return {
				loginState,
				doGmailLogin,
				logout,
				isRequestingAccessDoctor,
				keyword,
				verifyIsDoctor,
				isVerifyingDoctor,
			};
		},
	});
